module.exports = __webpack_public_path__ + "img/minus_btn.6d1f1f21.png";